import Button from "@mui/material/Button";
import Modal from "components/modal/modal";
import { AppAction, AppContext } from "helpers/context";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import styles from "./delete-location.module.scss";
import { deleteLocationsetsItems } from "api/layer";
import { LocationData } from "helpers/models";

function DeleteLocationModal() {
  const [context, dispatch] = useContext(AppContext);
  const deleteLocationModal = context.deleteLocationModal;
  const locationSets = context.locationSets;
  const [t] = useTranslation();

  const close = (): void => {
    dispatch({
      type: AppAction.setDeleteLocationModal,
      payload: undefined
    });
  };

  const deleteLocation = (): void => {
    if (!deleteLocationModal) {
      return;
    }

    deleteLocationsetsItems(
      context.currentMultipleLocations!.id,
      deleteLocationModal.id
    ).then(async (result) => {
      let updatedCurrentLocationSet: any = context.currentMultipleLocations;
      updatedCurrentLocationSet.items = updatedCurrentLocationSet.items?.filter(
        (location: LocationData) =>
          location.id.split("-").join("") !==
          deleteLocationModal.id.split("-").join("")
      );
      let updatedLocationSets = locationSets?.map(
        (locationSet: any) => {
          if (locationSet.id === updatedCurrentLocationSet.id) {
            locationSet.items = updatedCurrentLocationSet.items;
            locationSet.itemCount = updatedCurrentLocationSet.items?.length || 0;
          }
          return locationSet;
        }
      );

      if (context.hazardMultipleAnalysisStore) {
        let hazardMultipleAnalysisStore = context.hazardMultipleAnalysisStore;
        hazardMultipleAnalysisStore?.forEach((item, key) => {
          if (item.has(deleteLocationModal.id.split("-").join(""))) {
            item.delete(deleteLocationModal.id.split("-").join(""));
          }
        });
        dispatch({
          type: AppAction.setHazardMultipleAnalysisStore,
          payload: hazardMultipleAnalysisStore
        });
      }

      if (
        context.climateMultipleAnalysisResult &&
        context.climateMultipleAnalysisResult.length > 0
      ) {
        let climateMultipleAnalysisResult =
          context.climateMultipleAnalysisResult.filter(
            (locationSet: any) =>
              locationSet.id.split("-").join("") !==
                deleteLocationModal.id.split("-").join("")
          );
        dispatch({
          type: AppAction.setClimateMultipleAnalysisResult,
          payload: climateMultipleAnalysisResult
        });
      }

      dispatch({
        type: AppAction.setLocationSets,
        payload: updatedLocationSets
      });
      dispatch({
        type: AppAction.setCurrentMultipleLocations,
        payload: updatedCurrentLocationSet
      });
      dispatch({
        type: AppAction.addSnackBarParams,
        payload: {
          title: "deleteLocationTitle",
          titleData: deleteLocationModal.name
        }
      });

      // if (currentMultipleLocations!.items?.length === 0) {
      // 	dispatch({ type: AppAction.setMultipleLocationsEdit, payload: false });
      // }
    });

    close();
  };

  return (
    deleteLocationModal && (
      <Modal
        header={t("deleteLocation.title")}
        opened={deleteLocationModal}
        onClose={close}
      >
        <div className={styles.info}>
          <div
            className={styles.text}
          >{`${t("deleteLocation.prefix")}${deleteLocationModal.name}${t("deleteLocation.suffix")}`}</div>

          <div className={styles.button}>
            <Button
              variant="text"
              color="success"
              onClick={close}
              style={{ outline: "none" }}
            >
              {t("buttons.cancel")}
            </Button>
            &nbsp;&nbsp;
            <Button variant="contained" color="error" onClick={deleteLocation}>
              {t("buttons.delete")}
            </Button>
          </div>
        </div>
      </Modal>
    )
  );
}

export default DeleteLocationModal;

